import { render, staticRenderFns } from "./SendPendency.vue?vue&type=template&id=25092975&scoped=true&"
import script from "./SendPendency.vue?vue&type=script&lang=js&"
export * from "./SendPendency.vue?vue&type=script&lang=js&"
import style0 from "./SendPendency.vue?vue&type=style&index=0&id=25092975&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25092975",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
